import React from "react";
import { TableCell, TableRow } from "@material-ui/core";

import { ListingTableHeaderRowProps } from "./listing-table-header-row.props";
import { useListingTableStyles } from "../listing-table.styles";
import Typography from "@material-ui/core/Typography";

export const ListingTableHeaderRow = (props: ListingTableHeaderRowProps) => {
  const classes = useListingTableStyles();

  return (
    <TableRow className={classes.headerRow}>
      <TableCell
        className={classes.rowCell}
        colSpan={props.columns.length}
        component="th"
        scope="row"
      >
        <div className={classes.rowText}>
          <Typography variant="h5">{props.row.label}</Typography>
        </div>
      </TableCell>
    </TableRow>
  );
};
